import React from 'react';
import './Storia.css';

const testoStoria = `
Il C.U.S.A.S. (Centro Universitario Sannita Alleanza Studenti) è la principale associazione studentesca dell'Università degli Studi del Sannio (UniSannio), fondata nell'autunno del 1991. È la più longeva realtà associativa universitaria della provincia di Benevento e ha avuto un ruolo fondamentale nella storia recente dell'ateneo.

📜 Storia e Origini
Il C.U.S.A.S. è nato per dare voce agli studenti beneventani, inizialmente iscritti alla sede distaccata dell'Università degli Studi di Salerno, lontani dalla sede principale. Fin dai suoi primi anni, l'associazione si è distinta per l'impegno nella promozione dell'autonomia dell'Università del Sannio, raggiunta nel 1998. Un episodio emblematico di questa lotta è lo "sciopero dei panini", che portò all'apertura di una mensa universitaria a Benevento. Inoltre, il C.U.S.A.S. è stato promotore dell'istituzione del Comitato di Ateneo per lo Sport, ancora attivo oggi.

🤝 Confederazione e Struttura
Nel corso degli anni, il C.U.S.A.S. ha evoluto la sua struttura organizzativa. Nel 2022, ha costituito una Confederazione insieme ad altre tre associazioni studentesche, ciascuna rappresentante di un dipartimento dell'ateneo:

Alleanza Studenti DEMM (Dipartimento di Diritto, Economia, Management e Metodi Quantitativi)
Alleanza Studenti DING (Dipartimento di Ingegneria)
Alleanza Studenti DST (Dipartimento di Scienze e Tecnologie)

Questa forma confederale ha permesso una maggiore efficacia nella rappresentanza e nell'organizzazione di attività, affrontando le tematiche da un punto di vista dipartimentale. La Confederazione ha anche espresso rappresentanti in organi di governo dell'ateneo e in enti regionali e nazionali, come l'ADISURC e il Consiglio Nazionale degli Studenti Universitari (CNSU).

🎯 Missione e Attività
Il C.U.S.A.S. si riconosce nei principi dell'associazionismo studentesco, promuovendo:

• Responsabilità verso il sistema universitario
• Democrazia interna e partecipazione attiva
• Sviluppo sociale e benessere della comunità studentesca
• Solidarietà e inclusione

L'associazione si impegna a garantire l'accesso al sapere e a valorizzare il ruolo sociale degli studenti, affrontando le sfide di un sistema universitario che spesso penalizza gli atenei di piccole dimensioni come quello sannita. Promuove attività culturali, convegnistiche, seminariali, sportive e di aggregazione, contribuendo alla crescita personale e professionale degli studenti.

📍 Contatti e Presenza Online
Per rimanere aggiornati sulle attività e gli eventi organizzati dal C.U.S.A.S., è possibile seguire i loro canali ufficiali:

Facebook: Cusas Benevento
Instagram: @cusas_unisannio
feste ed eventi: @project_cusas

Inoltre, l'associazione è iscritta all'Albo delle Associazioni Studentesche dell'UniSannio, riconosciuto ufficialmente dall'ateneo.
`;

export default function Storia() {
  return (
    <div className="storia-container">
      <h1 className="storia-title">La Storia del C.U.S.A.S.</h1>
      <pre className="storia-text">{testoStoria}</pre>
    </div>
  );
}
